import { render, staticRenderFns } from "./BotView.vue?vue&type=template&id=60aa665c&scoped=true&"
import script from "./BotView.vue?vue&type=script&lang=js&"
export * from "./BotView.vue?vue&type=script&lang=js&"
import style0 from "./BotView.vue?vue&type=style&index=0&id=60aa665c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aa665c",
  null
  
)

export default component.exports